import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export function ProtectedMatchmakerRoute({ children }: { children: React.ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const [hasMatchmakerRole, setHasMatchmakerRole] = useState<boolean | null>(null);
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const checkMatchmakerRole = async () => {
      if (!user) {
        setCheckingRole(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id)
          .eq("role", "matchmaker")
          .maybeSingle();

        if (error) throw error;

        setHasMatchmakerRole(!!data);
      } catch (error) {
        console.error("auth.matchmaker_role_check_failed");
        setHasMatchmakerRole(false);
      } finally {
        setCheckingRole(false);
      }
    };

    checkMatchmakerRole();
  }, [user]);

  if (authLoading || checkingRole) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (hasMatchmakerRole === false) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
